import { render, staticRenderFns } from "./FcFeaturedSearches.vue?vue&type=template&id=afe486a0&"
import script from "./FcFeaturedSearches.vue?vue&type=script&lang=js&"
export * from "./FcFeaturedSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports